// extracted by mini-css-extract-plugin
export default {"root":"Invitation__root--2EJod","clickable-icon":"Invitation__clickable-icon--WPdBX","button":"Invitation__button--2K8Y3"};